var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachmentDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99 24a6.037 6.037 0 01-4.282-1.77 6.061 6.061 0 010-8.563L14.993 1.383a4.734 4.734 0 016.687 0 4.734 4.734 0 010 6.687L11.244 18.505a3.406 3.406 0 01-4.812 0 3.406 3.406 0 010-4.811l7.983-7.983c.22-.22.576-.22.796 0l.265.265c.22.22.22.576 0 .796l-7.983 7.982a1.904 1.904 0 000 2.69 1.904 1.904 0 002.69 0L20.62 7.01a3.232 3.232 0 000-4.565 3.232 3.232 0 00-4.566 0L3.77 14.728a4.56 4.56 0 000 6.44 4.56 4.56 0 006.44 0l10.207-10.206c.22-.22.576-.22.796 0l.265.265c.22.22.22.576 0 .796L11.271 22.23A6.035 6.035 0 016.989 24z",
    fill: "#DADADA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentDisabled);
export default __webpack_public_path__ + "static/media/attachment-disabled.58444942730b044e044422ea9399c963.svg";
export { ForwardRef as ReactComponent };